/**
 * Errors a court_bookings insert raises when another booking or a fixed-slot
 * hold claimed the same court/coach first (the slot was free when the customer
 * loaded it). createCourtBooking rewrites the exclusion constraint to the
 * "no longer available" sentence; the others surface as Postgres text:
 *   - idx_unique_court_booking_slot_active: identical-slot unique index (23505)
 *   - kit.enforce_fixed_slot_resource_release: tenants with a fixed-slot
 *     release policy reject occupied or held resources before the index runs
 */
const SLOT_CONFLICT_MARKERS = [
  'This time slot is no longer available',
  'court_bookings_no_overlap',
  'idx_unique_court_booking_slot_active',
  'Fixed-slot release: resource_already_booked',
  'Fixed-slot release: fixed_slot_not_released',
];

export function isSlotConflictError(message: string | null | undefined) {
  return (
    !!message && SLOT_CONFLICT_MARKERS.some((marker) => message.includes(marker))
  );
}
